import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ModalHeader from "../header/subHeader";
import { RouteComponentProps } from "react-router-dom";
import { IProject, IApplicationState, IAuthenticationState } from "../../../../models/applicationState";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IUserDefinedActions, * as userDefinedActions from "../../../../redux/actions/userDefinedActions";
import HeaderComponent from "../header/header";
import UserValidations from "./uservalidations";
import UserTransformations from "./usertransformations";
import nodejs from "../../../../assets/images/code-ico/nj.png";
import ruby from "../../../../assets/images/code-ico/ruby.png";
import js from "../../../../assets/images/code-ico/js.png";
import python from "../../../../assets/images/code-ico/python.png";
import c_sharp from "../../../../assets/images/code-ico/c_sharp.png";
import java from "../../../../assets/images/code-ico/java.png";
import UserFunctions from "./userFunctions";
import GenerateEndpoint from "./generateEndPoint";


export interface IAdvancedFeaturesProps extends RouteComponentProps, React.Props<AdvancedFeatures> {
    project: IProject;
    path: object;
    actions: IProjectActions;
    loggedInUser: IAuthenticationState;
    userDefinedActions: IUserDefinedActions;
    recentProjects: IProject[];
}

const textStyle = {
    color: 'green', fontStyle: 'italic'
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
        loggedInUser: state.loggedInUser,
        recentProjects: state.recentProjects,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch)
    };
}

export interface IAdvancedFeaturesState {
    project: IProject;
    selectedFeature: string;
    codesList: any[];
    isActivePython: string,
    isActiveNode: string,
    isPython: boolean,
    isNode: boolean,
    isJava: boolean,
    isCHash: boolean,
    isJS: boolean,
    isRuby: boolean,
    isActiveJS: string,
    isActiveCHash: string,
    isActiveJava: string,
    isActiveruby: string
}

@connect(mapStateToProps, mapDispatchToProps)

export default class AdvancedFeatures
    extends React.Component<IAdvancedFeaturesProps, IAdvancedFeaturesState> {
    public state: IAdvancedFeaturesState = {
      
        selectedFeature: "functions",        
        project: this.props.project,
        isPython: true,
        isNode: false,
        isJava: false,
        isCHash: false,
        isJS: false,
        isRuby: false,
        isActivePython: 'active',
        isActiveNode: '',
        isActiveJS: '',
        isActiveCHash: '',
        isActiveJava: '',
        isActiveruby: '',
        codesList: [
            { title: "Python", value: "python", image: python, active: "active" },
            { title: "Node JS", value: "nodejs", image: nodejs, active: "" },
            { title: "Java", value: "java", image: java, active: "" },
            { title: "C#", value: "c_sharp", image: c_sharp, active: "" },
            { title: "Java Script", value: "js", image: js, active: "" },
            { title: "Ruby", value: "ruby", image: ruby, active: "" },
        ]
    };



    public render() {
        const { selectedFeature } = this.state;
        return (
            <>
                <HeaderComponent
                    history={this.props.history}
                    match={this.props.match}
                    location={this.props.location} />
                <ModalHeader
                    history={this.props.history}
                    match={this.props.match}
                    actions={this.props.actions}
                    location={this.props.location}
                    project={this.props.project}
                />

                <section id="tabs" className="project-tab">
                    <nav
                        className="navbar navbar-expand-md bg-dark navbar-dark l-2 text-center"
                        id="nav-tab"
                        role="tablist"
                    >
                        <ul className="navbar-nav nav">
                        <li className="nav-item ">
                                <a
                                    className="nav-link active"
                                    id="nav-profile-tab"
                                    data-toggle="tab"
                                    onClick={() => this.selectedEndPoint("functions")}
                                    href="#functions"
                                    role="tab"
                                    aria-controls="nav-profile"
                                    aria-selected="false"
                                >
                                    User Defined Functions
                                </a>
                            </li>

                      {/*
                            <li className="nav-item ">
                                <a
                                    className="nav-link"
                                    id="nav-profile-tab"
                                    data-toggle="tab"
                                    onClick={() => this.selectedEndPoint("GenerateEndPoints")}
                                    href="#GenerateEndPoints"
                                    role="tab"
                                    aria-controls="nav-profile"
                                    aria-selected="false"
                                >
                                    Generate End Points
                                </a>
                            </li>

                            <li className="nav-item ">
                                <a
                                    className="nav-link"
                                    id="nav-home-tab"
                                    data-toggle="tab"
                                    href="#validation"
                                    onClick={() => this.selectedEndPoint("validation")}
                                    role="tab"
                                    aria-controls="nav-home"
                                    aria-selected="true"
                                >
                                    User Defined Validation
                                </a>
                            </li>


                            <li className="nav-item ">
                                <a
                                    className="nav-link"
                                    id="nav-profile-tab"
                                    data-toggle="tab"
                                    href="#transformation"
                                    onClick={() => this.selectedEndPoint("transform")}
                                    role="tab"
                                    aria-controls="nav-profile"
                                    aria-selected="false"
                                >
                                    User Defined Transformation
                                </a>
                            </li>
*/}
                            
                        </ul>
                    </nav>

                    <div className="tab-content" id="nav-tabContent">
                        <div className="tab-pane fade show" id="validation" role="tabpanel" aria-labelledby="nav-home-tab" >
                            {selectedFeature && selectedFeature === "validation" &&

                                <UserValidations
                                    history={this.props.history}
                                    match={this.props.match}
                                    userDefinedActions={this.props.userDefinedActions}
                                    actions={this.props.actions}
                                    location={this.props.location}
                                    project={this.props.project}
                                   
                                    />
                            }
                        </div>
                         <div className="tab-pane fade" id="functions" role="tabpanel" aria-labelledby="nav-profile-tab" >
                            {
                            /*
                            selectedFeature && selectedFeature === "functions" &&

                                <UserFunctions
                                    history={this.props.history}
                                    match={this.props.match}
                                    userDefinedActions={this.props.userDefinedActions}
                                    actions={this.props.actions}
                                    location={this.props.location}
                                    project={this.props.project}
                                    recentProjects ={this.props.recentProjects}
                                    />*/
                            }
                        </div>

                        <div className="tab-pane fade" id="transformation" role="tabpanel" aria-labelledby="nav-profile-tab" >
                            {selectedFeature && selectedFeature === "transform" &&

                                <UserTransformations
                                    history={this.props.history}
                                    match={this.props.match}
                                    userDefinedActions={this.props.userDefinedActions}
                                    actions={this.props.actions}
                                    location={this.props.location}
                                    project={this.props.project} />
                            }
                        </div>

                        <div className="tab-pane fade" id="GenerateEndPoints" role="tabpanel" aria-labelledby="nav-profile-tab" >
                            {selectedFeature && selectedFeature === "GenerateEndPoints" &&

                                <GenerateEndpoint
                                    history={this.props.history}
                        match={this.props.match}
                                    userDefinedActions={this.props.userDefinedActions}
                                    actions={this.props.actions}
                                    location={this.props.location}
                                    project={this.props.project} />
                            }
                        </div>   
                    </div>
              
            
             


                        <div className="tab-pane fade show active" id="functions" role="tabpanel" aria-labelledby="nav-home-tab" >
                                                           <div className="col-md-12">
                                       
                                        
                                            <section id="tabs">                                            
                                                <div className="tab-content py-3 px-3 px-sm-0" id="nav-tabContent">
                                                    <div className="tab-pane fade show active" id="nav-validation" role="tabpanel" aria-labelledby="nav-validation-tab">
                                                  
                                <UserFunctions
                                    history={this.props.history}
                                    match={this.props.match}
                                    userDefinedActions={this.props.userDefinedActions}
                                    actions={this.props.actions}
                                    location={this.props.location}
                                    project={this.props.project}
                                    recentProjects ={this.props.recentProjects}
                                    />    
</div></div>
                </section>  </div>    
                      </div>              
                </section>
            </>
        );
    }

    /**
     * Get selected EndPoint
     */
    private selectedEndPoint = (endPoint) => {
        this.setState({ selectedFeature: endPoint });
    }

}
